var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videoId !== '')?_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":("//fast.wistia.com/embed/iframe/" + _vm.videoId + ".jsonp"),"allowfullscreen":"","sandbox":"allow-scripts"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }